import React from 'react'

function Location() {
    return (
        <>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3724.6265480339143!2d105.80597047555777!3d21.007601980636395!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3135adfbac8aad55%3A0x1c064beb28064a02!2sF.Learning%20Studio!5e0!3m2!1svi!2s!4v1748942871899!5m2!1svi!2s" width="100%" height="500" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </>
    )
}

export default Location